import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { env } from "../env";
import { getLocalStorage } from "../utils/function/localStorage";

export const leaderBoardApi = createApi({
  reducerPath: "leaderBoardApi",
  keepUnusedDataFor: 180,
  baseQuery: fetchBaseQuery({
    baseUrl: env.BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("X-Auth-Token", getLocalStorage("tp_Aa_uth_access"));
      return headers;
    },
  }),
  tagTypes: ["leaderBoard"],
  endpoints: (builder) => ({
    dailyLeaderBoard: builder.query({
      query: () => "/secure/daily_leaderboard_live_data",
      providesTags: ["leaderBoard"],
    }),
    weeklyLeaderBoard: builder.query({
      query: () => "/secure/weekly_leaderboard_live_data",
      providesTags: ["leaderBoard"],
    }),
    getQuizDetail: builder.query({
      query: () => ({
        url: `/secure/quizDetailUser`,
      }),
      providesTags: ["leaderBoard"],
    }),
    getQuizHistory: builder.query({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: `/secure/getPreviousQuizHistory?page=${page}&limit=${limit}`,
        // params: {page, limit},
      }),
      providesTags: ["leaderBoard"],
    }),
    getQuizHistory: builder.query({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: `/secure/getPreviousQuizHistory?page=${page}&limit=${limit}`,
        // params: {page, limit},
      }),
      providesTags: ["leaderBoard"],
    }),
    monthlyLeaderBoard: builder.query({
      query: () => "/secure/monthly_leaderboard_live_data",
      providesTags: ["leaderBoard"],
    }),
    allLeaderBoardHistory: builder.query({
      query: () => "/secure/all_leaderboard_history",
      providesTags: ["leaderBoard"],
    }),
    // Add these inside your endpoints(builder) => ({ ... })
    getMyRankProgress: builder.query({
      query: () => '/secure/get_my_rank_progress',
      providesTags: ["leaderBoard"],
    }),
    updateMyRank: builder.mutation({

      query: (body) => ({

        url: '/secure/update-my-rank', // Adjust the prefix (/secure) if your backend uses a different route base

        method: 'PUT',

        body,

      }),

      invalidatesTags: ['leaderBoard'], // This triggers a refresh of the leaderboard data

    }),
    getUsersRank: builder.query({
      query: (username) => `/secure/get-users-rank?username=${username}`,
      providesTags: ["leaderBoard"],
    }),
    claimNow: builder.mutation({
      query: (body) => ({
        url: "/secure/claim-now",
        method: "POST",
        body,
      }),
      invalidatesTags: ["leaderBoard"],
    }),
    spinWheelClaim: builder.mutation({
      query: (amount) => ({
        url: "/secure/spinWheelClaim",
        method: "POST",
        body: amount,
      }),
    }),
    getAllMysteryBox: builder.query({
      query: () => "/secure/get-all-mistbow",
      providesTags: ["leaderBoard"],
    }),
    getUserPointAnalytics: builder.query({
      query: () => '/secure/get_user_point_analytics',
      providesTags: ['leaderBoard'],
    }),
    claimBtn: builder.query({
      query: () => "/secure/claim-button",
      providesTags: ["leaderBoard"],
    }),
    getLeaderBoardData: builder.query({
      query: ({ page, limit }) =>
        `/secure/get_leader_board_data?page=${page}&limit=${limit}`,
      providesTags: ["leaderBoard"],
    }),
    getMyPointHistory: builder.query({
      query: ({ page, limit, type }) =>
        `/secure/get_user_all_point_history?page=${page}&limit=${limit}&type=${type}`,
      providesTags: ["leaderBoard"],
    }),
    getTotalPoints: builder.query({
      query: () => "/secure/get_total_points",
      providesTags: ["leaderBoard"],
    }),
    getLeaderBoardUserInfo: builder.query({
      query: (username) =>
        `/secure/get-leader-board-user-info?username=${username}`,
      providesTags: ["leaderBoard"],
    }),
    getAllPurposeIcons: builder.query({
      query: () => "/secure/getUserPurposeIcon",
      transformResponse: (response) => response.data,
    }),

    getReferralLeaderBoardLiveData: builder.query({
      query: ({ page, limit, type }) => {
        const actualType = type ? type : "daily";
        return `/secure/getReferralLeaderBoardLiveData?type=${actualType}&${actualType}Page=${page}&${actualType}Limit=${limit}`;
      },
      providesTags: ["leaderBoard"],
    }),

    allLeaderBoardLiveData: builder.query({
      query: ({ page, limit, type }) => {
        const actualType = type ? type : "daily";
        return `/secure/getAllLeaderBoardLiveData?type=${actualType}&${actualType}Page=${page}&${actualType}Limit=${limit}`;
      },
      providesTags: ["leaderBoard"],
    }),

    allLeaderBoardLiveDataV2: builder.query({
      query: ({ page, limit, category = "leaderboard", type = "daily" }) =>
        `/secure/getAllLeaderBoardLiveDataV2?category=${category}&type=${type}&page=${page}&limit=${limit}`,

    }),

    fetchMyAllLeaderBoardLiveDataV2: builder.query({
      query: (arg = {}) => {
        const { specificUsername } = arg;

        return {
          url: `/secure/fetchMyAllLeaderBoardLiveDataV2`,
          params: { specificUsername },
        };
      },
    }),

    getMyLeaderboardData: builder.query({
      query: ({ type = "daily", category = "leaderboard" }) => {
        return `/secure/getMyLeaderboardData?type=${type}&category=${category}`;
      },
      providesTags: ["leaderBoard"],
    }),

    getAllQuizLeaderBoardLiveData: builder.query({
      query: ({ page, limit, type }) => {
        const actualType = type ? type : "daily";
        return `/secure/getAllQuizLeaderBoardLiveData?type=${actualType}&${actualType}Page=${page}&${actualType}Limit=${limit}`;
      },
      providesTags: ["leaderBoard"],
    }),
    spinCountToday: builder.query({
      query: () => {
        return `/secure/spinCountToday`;
      },
      providesTags: ["leaderBoard"],
    }),
    buyReferralSpin: builder.mutation({
      query: (amount) => ({
        url: "/secure/buyReferralSpin",
        method: "POST",
        body: amount,
      }),
    }),
    buyReferralSpinCountToday: builder.query({
      query: () => {
        return `/secure/buyReferralSpinCountToday`;
      },
      providesTags: ["leaderBoard"],
    }),

    getBuyReferralSpin: builder.query({
      query: () => '/secure/getBuyReferralSpin',
    }),

    checkClaimLeaderboardPoints: builder.query({
      query: ({ timeType }) => ({
        url: `/secure/check-claim-leaderboard-points?timeType=${timeType}`,
        method: 'GET',
      }),
      providesTags: ['leaderBoard'],
    }),

    checkClaimQuizLeaderboardPoints: builder.query({
      query: ({ timeType }) => ({
        url: `/secure/check-claim-quiz-leaderboard-points?timeType=${timeType}`,
        method: 'GET',
      }),
      providesTags: ['leaderBoard'],
    }),

    checkClaimReferralLeaderboardPoints: builder.query({
      query: ({ timeType }) => ({
        url: `/secure/check-claim-referral-leaderboard-points?timeType=${timeType}`,
        method: 'GET',
      }),
      providesTags: ['leaderBoard'],
    }),

    claimLeaderboardPoints: builder.mutation({
      query: ({ timeType }) => ({
        url: '/secure/claim-leaderboard-points',
        method: 'POST',
        body: { timeType },
      }),
      invalidatesTags: ['leaderBoard'],
    }),

    claimQuizLeaderboardPoints: builder.mutation({
      query: ({ timeType }) => ({
        url: '/secure/claim-quiz-leaderboard-points',
        method: 'POST',
        body: { timeType },
      }),
      invalidatesTags: ['leaderBoard'],
    }),
    getMyTaskPointHistory: builder.query({
      query: ({ page = 1, limit = 20, filter = "" }) => ({
        url: "/secure/my-task-point-history",
        method: "GET",
        params: { page, limit, filter },
      }),
      providesTags: ["taskpoint"],
    }),

    claimReferralLeaderboardPoints: builder.mutation({
      query: ({ timeType }) => ({
        url: '/secure/claim-referral-leaderboard-points',
        method: 'POST',
        body: { timeType },
      }),
      invalidatesTags: ['leaderBoard'],
    }),
    getActiveTaskPointRanks: builder.query({
      query: ({ category = "leaderboard", type = "daily" }) =>
        `/secure/get_active_task_point_ranks?category=${category}&type=${type}`,
      providesTags: ['leaderBoard', 'taskpoint'],
    }),





    checkClaimLeaderboardPointsV2: builder.query({
      query: ({ timeType }) => ({
        url: `/secure/check-claim-leaderboard-pointsv2?timeType=${timeType}`,
        method: 'GET',
      }),
      providesTags: ['leaderBoard'],
    }),

    checkClaimQuizLeaderboardPointsV2: builder.query({
      query: ({ timeType }) => ({
        url: `/secure/check-claim-quiz-leaderboard-pointsv2?timeType=${timeType}`,
        method: 'GET',
      }),
      providesTags: ['leaderBoard'],
    }),

    checkClaimReferralLeaderboardPointsV2: builder.query({
      query: ({ timeType }) => ({
        url: `/secure/check-claim-referral-leaderboard-pointsv2?timeType=${timeType}`,
        method: 'GET',
      }),
      providesTags: ['leaderBoard'],
    }),

    claimLeaderboardPointsV2: builder.mutation({
      query: ({ timeType }) => ({
        url: '/secure/claim-leaderboard-pointsv2',
        method: 'POST',
        body: { timeType },
      }),
      invalidatesTags: ['leaderBoard'],
    }),

    claimQuizLeaderboardPointsV2: builder.mutation({
      query: ({ timeType }) => ({
        url: '/secure/claim-quiz-leaderboard-pointsv2',
        method: 'POST',
        body: { timeType },
      }),
      invalidatesTags: ['leaderBoard'],
    }),

    claimReferralLeaderboardPointsV2: builder.mutation({
      query: ({ timeType }) => ({
        url: '/secure/claim-referral-leaderboard-pointsv2',
        method: 'POST',
        body: { timeType },
      }),
      invalidatesTags: ['leaderBoard'],
    }),

    getAllUnclaimedPointsInSequenceV2: builder.query({
      query: () => ({
        url: '/secure/get-all-unclaimed-points-sequencev2',
        method: 'GET',
      }),
      providesTags: ['leaderBoard'],
    }),

    claimPointByIdV2: builder.mutation({
      query: ({ id, timeType, category }) => ({
        url: '/secure/claim-point-by-idv2',
        method: 'POST',
        body: { id, timeType, category },
      }),
      invalidatesTags: ['leaderBoard'],
    }),
  }),
});

export const {
  useGetActiveTaskPointRanksQuery,
  useDailyLeaderBoardQuery,
  useWeeklyLeaderBoardQuery,
  useMonthlyLeaderBoardQuery,
  useAllLeaderBoardHistoryQuery,
  useClaimNowMutation,
  useSpinWheelClaimMutation,
  useGetAllMysteryBoxQuery,
  useClaimBtnQuery,
  useGetLeaderBoardDataQuery,
  useGetMyPointHistoryQuery,
  useGetTotalPointsQuery,
  useGetLeaderBoardUserInfoQuery,
  useGetAllPurposeIconsQuery,
  useGetQuizDetailQuery,
  useGetQuizHistoryQuery,
  useGetReferralLeaderBoardLiveDataQuery,
  useAllLeaderBoardLiveDataQuery,
  useAllLeaderBoardLiveDataV2Query,
  useFetchMyAllLeaderBoardLiveDataV2Query,
  useLazyGetMyLeaderboardDataQuery,
  useGetAllQuizLeaderBoardLiveDataQuery,
  useSpinCountTodayQuery,
  useBuyReferralSpinMutation,
  useBuyReferralSpinCountTodayQuery,
  useGetBuyReferralSpinQuery,
  useCheckClaimLeaderboardPointsQuery,
  useCheckClaimQuizLeaderboardPointsQuery,
  useCheckClaimReferralLeaderboardPointsQuery,
  useClaimLeaderboardPointsMutation,
  useClaimQuizLeaderboardPointsMutation,
  useClaimReferralLeaderboardPointsMutation,
  useLazyGetMyPointHistoryQuery,
  useGetMyTaskPointHistoryQuery,


  useGetMyRankProgressQuery,
  useUpdateMyRankMutation,
  useGetUsersRankQuery,
  useLazyGetUsersRankQuery,


  useCheckClaimLeaderboardPointsV2Query,
  useCheckClaimQuizLeaderboardPointsV2Query,
  useCheckClaimReferralLeaderboardPointsV2Query,

  useClaimLeaderboardPointsV2Mutation,
  useClaimQuizLeaderboardPointsV2Mutation,
  useClaimReferralLeaderboardPointsV2Mutation,

  useGetAllUnclaimedPointsInSequenceV2Query,
  useClaimPointByIdV2Mutation,
  useGetUserPointAnalyticsQuery,
} = leaderBoardApi;
